import axios from "axios";
import { API } from "@/lib/api";

export const getTestimonials = async () => (await axios.get(`${API}/testimonials`)).data;
export const shareTestimonial = async (body) => (await axios.post(`${API}/testimonials`, body)).data;
export const adminTestimonials = async () => (await axios.get(`${API}/testimonials/admin`)).data;
export const adminAddTestimonial = async (body) => (await axios.post(`${API}/testimonials/admin`, body)).data;
export const adminSetStatus = async (id, status) => (await axios.patch(`${API}/testimonials/admin/${id}`, { status })).data;
export const adminDelete = async (id) => (await axios.delete(`${API}/testimonials/admin/${id}`)).data;
